export const TYPE_RECORDING = 1
export const TYPE_GREETING = 2
export const TYPE_WHISPER = 3
export const TYPE_VOICEMAIL = 4
export const TYPE_PROMPT = 5
export const TYPE_CALL_RECORDING = 6
export const TYPE_CALL_VOICEMAIL = 7